import { DeepPartial } from 'redux';
import { AppState } from 'reduxStore/appStore';

export const latestReduxActions: { type: string; payload: any }[] = []; // Max 30 actions

export const wrappedReduxStateSnapshot: DeepPartial<{ state: AppState }> = {};
